import { Box, BoxProps } from "@chakra-ui/react";

function NewTabIcon({
  color = "#059669",
  size = 20,
  ...props
}: BoxProps & { color?: string; size?: number }) {
  return (
    <Box {...props}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.42345 17.0833C4.00248 17.0833 3.64616 16.9375 3.35449 16.6458C3.06283 16.3542 2.91699 15.9978 2.91699 15.5769V4.42312C2.91699 4.00215 3.06283 3.64583 3.35449 3.35416C3.64616 3.0625 4.00248 2.91666 4.42345 2.91666H9.0547C9.23206 2.91666 9.3806 2.97653 9.50033 3.09625C9.61991 3.21583 9.6797 3.3643 9.6797 3.54166C9.6797 3.71903 9.61991 3.8675 9.50033 3.98708C9.3806 4.1068 9.23206 4.16666 9.0547 4.16666H4.42345C4.35928 4.16666 4.30053 4.1934 4.2472 4.24687C4.19373 4.30021 4.16699 4.35896 4.16699 4.42312V15.5769C4.16699 15.641 4.19373 15.6998 4.2472 15.7531C4.30053 15.8066 4.35928 15.8333 4.42345 15.8333H15.5772C15.6414 15.8333 15.7001 15.8066 15.7535 15.7531C15.8069 15.6998 15.8337 15.641 15.8337 15.5769V10.9456C15.8337 10.7683 15.8935 10.6197 16.0132 10.5C16.1328 10.3804 16.2813 10.3206 16.4587 10.3206C16.636 10.3206 16.7845 10.3804 16.9041 10.5C17.0238 10.6197 17.0837 10.7683 17.0837 10.9456V15.5769C17.0837 15.9978 16.9378 16.3542 16.6462 16.6458C16.3545 16.9375 15.9982 17.0833 15.5772 17.0833H4.42345ZM15.8337 5.04479L8.53887 12.3398C8.42345 12.4551 8.27838 12.5141 8.10366 12.5169C7.92908 12.5195 7.78137 12.4605 7.66053 12.3398C7.53984 12.219 7.47949 12.0726 7.47949 11.9006C7.47949 11.7287 7.53984 11.5823 7.66053 11.4615L14.9555 4.16666H12.292C12.1146 4.16666 11.9662 4.1068 11.8466 3.98708C11.7269 3.8675 11.667 3.71903 11.667 3.54166C11.667 3.3643 11.7269 3.21583 11.8466 3.09625C11.9662 2.97653 12.1146 2.91666 12.292 2.91666H16.3303C16.5452 2.91666 16.7244 2.98854 16.868 3.13229C17.0118 3.2759 17.0837 3.45514 17.0837 3.67V7.70833C17.0837 7.88569 17.0238 8.03416 16.9041 8.15375C16.7845 8.27347 16.636 8.33333 16.4587 8.33333C16.2813 8.33333 16.1328 8.27347 16.0132 8.15375C15.8935 8.03416 15.8337 7.88569 15.8337 7.70833V5.04479Z"
          fill={color}
        />
      </svg>
    </Box>
  );
}

export { NewTabIcon };
